module.exports = __webpack_public_path__ + "img/Wp_2026.5133f4c3.png";